const config = {
  graph: {
    host: 'http://0.0.0.0:8010/graph',
  },
  sites: {
    host: 'http://127.0.0.1:8020',
  },
  sentry: {
    environment: 'local',
  },
  map: {
    token:
      'pk.eyJ1IjoibWtnbyIsImEiOiJjanR2aG1mcmQwcmMxNGRtc21ya2R0MXlwIn0.VC0Opy6VaVseVXPF2g2lHw',
  },
  intercom: {
    appId: 'c0jvqtbl',
  },
  stripe: {
    publishableKey: 'pk_test_JguUTau3KP7pLwfXopOfonHT00KZ1zOeip',
  },
  features: [
    { featureName: 'GlobalSearchBar', enabled: false },
    { featureName: 'NotificationBell', enabled: false },
    { featureName: 'SupportSection', enabled: false },
    { featureName: 'ActivitySection', enabled: false },
    { featureName: 'BillingBasicFeature', enabled: true },
    { featureName: 'BillingPlusFeature', enabled: true },
    { featureName: 'BillingProFeature', enabled: true },
    { featureName: 'IntegrationsSection', enabled: true },
    { featureName: 'SocialNetworkFBFeature', enabled: true },
    { featureName: 'SocialNetworkInstagramFeature', enabled: true },
    { featureName: 'SocialNetworkTwitterFeature', enabled: true },
    { featureName: 'SocialNetworkLinkedInFeature', enabled: true },
  ],
};
export default config;
